import { StorageOutlined } from "@mui/icons-material";
import { IconButton } from "@mui/material";

import { ProjectsList } from "../ProjectsList/ProjectsList";
import styles from "./ProjectsLeftBar.module.css";

export const ProjectsLeftBar = ({ showSidebar, toggleSidebar }) => {
	const containerClass = showSidebar ? `${styles.container} ${styles.open}` : `${styles.container}`;

	return (
		<div className={containerClass}>
			<div className={styles.wrapper}>
				<div className={styles.leftContainer}>
					<IconButton onClick={() => toggleSidebar()} title="Список проектов">
						<StorageOutlined />
					</IconButton>
				</div>
				<ProjectsList />
			</div>
		</div>
	);
};
